module.exports = __webpack_public_path__ + "static/iltasanomat29032008-140x140-8274.c669eacb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iltasanomat29032008-140x140-8274.jpg
// module id = 825
// module chunks = 129563053867776